import { atom } from "recoil";

// 従業員が属している企業Id
export const companyState = atom({
  key: "companyState",
  default: { company_id: null }
});